import { Button, Container, Icon } from "@fluidattacks/design";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { EntryConfigMenu } from "./entry-config-menu";

import { ChildrenContainer } from "components/dropdown/styles";
import { useClickOutside } from "hooks";

interface IActionButtonsProps {
  checkedAuthorsCount: number;
  isEntryConfigMenuVisible: boolean;
  onOpenCreateEntryModal: () => void;
  onOpenImportMailmapModal: () => void;
  onOpenUpdateEntryModal: () => void;
  onOpenSetEntryAsSubentryModal: () => void;
  onOpenDeleteEntryModal: () => void;
  onOpenMoveEntryWithSubentriesModal: () => void;
  onToggleEntryConfigMenu: () => void;
  onCloseEntryConfigMenu: () => void;
}

export const ActionButtons = ({
  checkedAuthorsCount,
  isEntryConfigMenuVisible,
  onOpenCreateEntryModal,
  onOpenImportMailmapModal,
  onOpenUpdateEntryModal,
  onOpenSetEntryAsSubentryModal,
  onOpenDeleteEntryModal,
  onOpenMoveEntryWithSubentriesModal,
  onToggleEntryConfigMenu,
  onCloseEntryConfigMenu,
}: IActionButtonsProps): JSX.Element => {
  const { t } = useTranslation();
  const entryConfigButtonRef = useRef<HTMLButtonElement>(null);

  useClickOutside(entryConfigButtonRef.current, onCloseEntryConfigMenu);

  const importMailmapButton = (
    <Button
      icon={"file-import"}
      id={"import-mailmap-button"}
      onClick={onOpenImportMailmapModal}
      tooltip={t("mailmap.tooltipImportMailmapButton")}
      tooltipPlace={"top"}
      variant={"ghost"}
    >
      {t("group.scope.git.addGitRootFile.button")}
    </Button>
  );

  const entryConfigButton = (
    <Button
      disabled={checkedAuthorsCount !== 1}
      onClick={onToggleEntryConfigMenu}
      ref={entryConfigButtonRef}
      variant={"ghost"}
    >
      <Icon
        clickable={false}
        icon={"gear"}
        iconSize={"lg"}
        iconType={"fa-light"}
      />
      {t("mailmap.entryConfig")}
      <Container zIndex={2}>
        <ChildrenContainer>
          <EntryConfigMenu
            isVisible={isEntryConfigMenuVisible}
            onOpenDeleteEntryModal={onOpenDeleteEntryModal}
            onOpenMoveEntryWithSubentriesModal={
              onOpenMoveEntryWithSubentriesModal
            }
            onOpenSetEntryAsSubentryModal={onOpenSetEntryAsSubentryModal}
            onOpenUpdateEntryModal={onOpenUpdateEntryModal}
          />
        </ChildrenContainer>
      </Container>
    </Button>
  );

  return (
    <Container gap={0.5} id={"actions-container"}>
      {importMailmapButton}
      {entryConfigButton}
      <Button icon={"plus"} onClick={onOpenCreateEntryModal}>
        {t("mailmap.createEntry")}
      </Button>
    </Container>
  );
};
